import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["polarity", "color", "size", "onClick", "Icon", "Wrapper"];
import styled from 'styled-components';
import { getInsightColorTrellis } from 'messaging-publishing-lib/Insights/utils';
import { ThumbsDownIcon, ThumbsUpIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "InsightIcon__Container",
  componentId: "sc-1hdyb64-0"
})(({
  $spaceCssStyles
}) => {
  return Object.assign({
    display: 'inline-block'
  }, $spaceCssStyles);
});
export function TInsightIcon(_ref) {
  let {
      polarity,
      color = getInsightColorTrellis(polarity),
      size = '200',
      onClick,
      Icon = polarity ? ThumbsUpIcon : ThumbsDownIcon,
      // Wrapper will get data-polarity attribute too
      Wrapper
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterTokenProps(props);
  const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
  const icon = /*#__PURE__*/_jsx(Container, {
    $spaceCssStyles: spaceCssStyles,
    children: /*#__PURE__*/_jsx(Icon, Object.assign({
      color: color,
      size: size,
      "data-polarity": polarity
    }, props))
  });
  const iconWithButton = /*#__PURE__*/_jsx(IconButton, {
    use: "unstyled",
    onClick: onClick,
    children: icon
  });
  const insightIcon = !onClick ? icon : iconWithButton;
  return Wrapper ? /*#__PURE__*/_jsx(Wrapper, {
    "data-polarity": polarity,
    children: insightIcon
  }) : insightIcon;
}

/**
 * Next step: rename all references to InsightIcon.
 * Final step: stop exporting TInsightIcon and rename it to InsightIcon to complete the replacement.
 */
export default TInsightIcon;